// GENERATED from docs/onboarding/ONBOARDING_SCRIPT.md (Line index table). Edit the doc, then re-sync the text here.
// Line ids = stepId_n; audio paths are placeholders for the Stage 2 player.
import type { TourLine, TourStep } from './types';

const L = (id: string, text: string): TourLine => ({ id, text, audio: `onboarding/audio/${id}.mp3` });

export const ONBOARDING_STEPS: TourStep[] = [
  {
    id: "p1_1", stop: 0, speaker: "syqi", screen: "compass",
    target: "mountain.up",
    waitFor: "nav:self",
    lines: [
      L("p1_1_1", "Hi, I'm SyQi. OLMPS puts your life in order."),
      L("p1_1_2", "This mountain is your life's shape: five SHAPE sectors. Social, Health, Admin, Personal, Economic."),
      L("p1_1_3", "The temple at the top is OLMPS, where your mind turns into your life. Tap the up arrow."),
    ],
  },
  {
    id: "p1_2", stop: 0, speaker: "syqi", screen: "self",
    target: "pantheon.down",
    waitFor: "nav:compass",
    lines: [
      L("p1_2_1", "This is the Pantheon. Every skill you build to run the mountain is a deity."),
      L("p1_2_2", "You'll meet them here, and work with them here."),
      L("p1_2_3", "Tap the down arrow to go back."),
    ],
  },
  {
    id: "p1_3", stop: 0, speaker: "syqi", screen: "compass",
    targets: ["life.compassPill", "life.mountainPill"],
    waitFor: ["life:mode:compass", "life:mode:mountain"],
    lines: [
      L("p1_3_1", "You can see one sector at a time, or all five at once."),
      L("p1_3_2", "Tap Compass for the full circle."),
      L("p1_3_3", "Now tap Mountain to come back."),
    ],
  },
  {
    id: "p1_4", stop: 0, speaker: "syqi", screen: "compass",
    target: "mountain.point",
    waitFor: "orb:open",
    lines: [
      L("p1_4_1", "Every point on the mountain opens an Orb."),
      L("p1_4_2", "Tap any point."),
    ],
  },
  {
    id: "p1_5", stop: 0, speaker: "syqi", screen: "orb",
    target: "orb.row",
    waitFor: "orb:expand",
    lines: [
      L("p1_5_1", "ORDER is five questions: Orient, Regulate, Direct, Execute, Revise."),
      L("p1_5_2", "Open any row to answer it, or use its deity's tool."),
      L("p1_5_3", "Tap a row."),
    ],
  },
  {
    id: "p1_6", stop: 0, speaker: "syqi", screen: "orb",
    targets: ["orb.up", "mountain.up"],
    waitFor: ["nav:compass", "nav:self"],
    lines: [
      L("p1_6_1", "That's the whole system. Now let's set it up."),
      L("p1_6_2", "I'll introduce you to five deities. Head back to the Mountain, then up to the Pantheon."),
    ],
  },
  {
    id: "s1_handoff", stop: 1, speaker: "syqi", screen: "self",
    targets: ["pantheon.tier.titan", "statue.telos"],
    waitFor: ["pantheon:tier:titan", "deity:open:telos"],
    lines: [
      L("s1_handoff_1", "First stop: Orient. Where am I going?"),
      L("s1_handoff_2", "ATLAS answers that. Turn the dial to ORDER 2. He's at the top. Tap him."),
    ],
  },
  {
    id: "s1_intro", stop: 1, speaker: "telos", screen: "self",
    target: "deityfocus.tool",
    waitFor: "nav:deitytool",
    lines: [
      L("s1_intro_1", "Welcome. I'm ATLAS. I set your direction."),
      L("s1_intro_2", "Your life has five sectors: Social, Health, Admin, Personal, Economic."),
      L("s1_intro_3", "Each one gets a single Endeavour, the big thing you're building."),
      L("s1_intro_4", "Now open my tool. Tap the arrow on the right."),
    ],
  },
  {
    id: "s1_action_social", stop: 1, speaker: "telos", screen: "deitytool",
    targets: ["atlas.chip.social", "atlas.endeavour", "atlas.endeavour.options"],
    waitFor: ["atlas:chip:social", "atlas:endeavour:open", "atlas:endeavour:social"],
    lines: [
      L("s1_action_social_1", "Tap Social, then tap Endeavour and pick the one that fits."),
    ],
  },
  {
    id: "s1_action_health", stop: 1, speaker: "telos", screen: "deitytool",
    targets: ["atlas.chip.health", "atlas.endeavour", "atlas.endeavour.options"],
    waitFor: ["atlas:chip:health", "atlas:endeavour:open", "atlas:endeavour:health"],
    lines: [
      L("s1_action_health_1", "Now Health. Tap it, then pick an Endeavour."),
    ],
  },
  {
    id: "s1_action_admin", stop: 1, speaker: "telos", screen: "deitytool",
    targets: ["atlas.chip.admin", "atlas.endeavour", "atlas.endeavour.options"],
    waitFor: ["atlas:chip:admin", "atlas:endeavour:open", "atlas:endeavour:admin"],
    lines: [
      L("s1_action_admin_1", "Admin next. Same again."),
    ],
  },
  {
    id: "s1_action_personal", stop: 1, speaker: "telos", screen: "deitytool",
    targets: ["atlas.chip.personal", "atlas.endeavour", "atlas.endeavour.options"],
    waitFor: ["atlas:chip:personal", "atlas:endeavour:open", "atlas:endeavour:personal"],
    lines: [
      L("s1_action_personal_1", "Personal. Pick one."),
    ],
  },
  {
    id: "s1_action_economic", stop: 1, speaker: "telos", screen: "deitytool",
    targets: ["atlas.chip.economic", "atlas.endeavour", "atlas.endeavour.options"],
    waitFor: ["atlas:chip:economic", "atlas:endeavour:open", "atlas:endeavour:economic"],
    lines: [
      L("s1_action_economic_1", "Last one, Economic."),
    ],
  },
  {
    id: "s1_save", stop: 1, speaker: "telos", screen: "deitytool",
    target: "atlas.save",
    waitFor: "atlas:saved",
    lines: [
      L("s1_save_1", "That's five. Tap Save."),
    ],
  },
  {
    id: "s1_done", stop: 1, speaker: "telos", screen: "deitytool",
    lines: [
      L("s1_done_1", "Five sectors, five Endeavours. Excellent. Five clicks."),
    ],
  },
  {
    id: "s1_return", stop: 1, speaker: "syqi", screen: "deitytool",
    target: "tool.back",
    waitFor: "nav:self",
    lines: [
      L("s1_return_1", "That's your direction set. Next, your time."),
      L("s1_return_2", "Back to the Pantheon. Find KRNOS."),
    ],
  },
  {
    id: "s2_handoff", stop: 2, speaker: "syqi", screen: "self",
    targets: ["pantheon.tier.titan", "statue.krnos"],
    waitFor: ["pantheon:tier:titan", "deity:open:krnos"],
    lines: [
      L("s2_handoff_1", "Second stop: your week. KRNOS keeps the time."),
      L("s2_handoff_2", "He's in ORDER 2, under Direct. Tap him."),
    ],
  },
  {
    id: "s2_intro", stop: 2, speaker: "krnos", screen: "self",
    target: "deityfocus.tool",
    waitFor: "nav:deitytool",
    lines: [
      L("s2_intro_1", "I'm KRNOS. I deal in time, not wishes."),
      L("s2_intro_2", "Your week already has fixed commitments. Work, school, family."),
      L("s2_intro_3", "Tell me what repeats weekly, and I'll build around it."),
      L("s2_intro_4", "Now open my tool. Tap the arrow on the right."),
    ],
  },
  {
    id: "s2_action_add", stop: 2, speaker: "krnos", screen: "deitytool",
    targets: ["krnos.add"],
    waitFor: ["krnos:add:open"],
    lines: [L("s2_action_add_1", "Tap Add Event to enter a weekly commitment.")],
  },
  {
    id: "s2_action_title", stop: 2, speaker: "krnos", screen: "deitytool",
    targets: ["krnos.title"],
    waitFor: ["krnos:title"],
    lines: [L("s2_action_title_1", "Type its name: work, school, family. Then press return.")],
  },
  {
    id: "s2_action_when", stop: 2, speaker: "krnos", screen: "deitytool",
    targets: ["krnos.day", "krnos.start", "krnos.end"],
    waitFor: ["krnos:day", "krnos:start", "krnos:end"],
    lines: [L("s2_action_when_1", "Pick its day, then set start and end times.")],
  },
  {
    id: "s2_action_repeat", stop: 2, speaker: "krnos", screen: "deitytool",
    targets: ["krnos.repeat.weekly"],
    waitFor: ["krnos:repeat:weekly"],
    lines: [L("s2_action_repeat_1", "Tap Weekly so it returns every week.")],
  },
  {
    id: "s2_action_save", stop: 2, speaker: "krnos", screen: "deitytool",
    targets: ["krnos.save"],
    waitFor: ["krnos:saved"],
    lines: [L("s2_action_save_1", "Tap Add Event to lock it in.")],
  },
  {
    id: "s2_done", stop: 2, speaker: "krnos", screen: "deitytool",
    lines: [
      L("s2_done_1", "Commitments locked. Now your week has room for the work."),
    ],
  },
  {
    id: "s2_return", stop: 2, speaker: "syqi", screen: "deitytool",
    target: "tool.back",
    waitFor: "nav:self",
    lines: [
      L("s2_return_1", "Your week has a shape now."),
      L("s2_return_2", "Next, the work itself. Find KYRS."),
    ],
  },
  {
    id: "s3_handoff", stop: 3, speaker: "syqi", screen: "self",
    targets: ["pantheon.tier.mortal", "statue.kyrs"],
    waitFor: ["pantheon:tier:mortal", "deity:open:kyrs"],
    lines: [
      L("s3_handoff_1", "Third stop: Direct. What do I do first?"),
      L("s3_handoff_2", "Turn the dial to ORDER 1. KYRS is under Direct. Tap him."),
    ],
  },
  {
    id: "s3_intro", stop: 3, speaker: "kyrs", screen: "self",
    target: "deityfocus.tool",
    waitFor: "nav:deitytool",
    lines: [
      L("s3_intro_1", "I'm KYRS. I keep the work in order."),
      L("s3_intro_2", "Every sector has its own task list."),
      L("s3_intro_3", "Give me one task per list, and I'll sort them."),
      L("s3_intro_4", "Now open my tool. Tap the arrow on the right."),
    ],
  },
  {
    id: "s3_action_social", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.social", "kyrs.quickadd", "kyrs.back"],
    waitFor: ["kyrs:list:social", "kyrs:added:social", "kyrs:lists"],
    lines: [L("s3_action_social_1", "Open Social, type one task, press return. Then go back.")],
  },
  {
    id: "s3_action_health", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.health", "kyrs.quickadd", "kyrs.back"],
    waitFor: ["kyrs:list:health", "kyrs:added:health", "kyrs:lists"],
    lines: [L("s3_action_health_1", "Open Health, type one task, press return. Then go back.")],
  },
  {
    id: "s3_action_admin", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.admin", "kyrs.quickadd", "kyrs.back"],
    waitFor: ["kyrs:list:admin", "kyrs:added:admin", "kyrs:lists"],
    lines: [L("s3_action_admin_1", "Open Admin, type one task, press return. Then go back.")],
  },
  {
    id: "s3_action_personal", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.personal", "kyrs.quickadd", "kyrs.back"],
    waitFor: ["kyrs:list:personal", "kyrs:added:personal", "kyrs:lists"],
    lines: [L("s3_action_personal_1", "Open Personal, type one task, press return. Then go back.")],
  },
  {
    id: "s3_action_economic", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.economic", "kyrs.quickadd", "kyrs.back"],
    waitFor: ["kyrs:list:economic", "kyrs:added:economic", "kyrs:lists"],
    lines: [L("s3_action_economic_1", "Open Economic, type one task, press return. Then go back.")],
  },
  {
    id: "s3_rate_view", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.list.social", "kyrs.view"],
    waitFor: ["kyrs:list:social", "kyrs:view:long"],
    lines: [L("s3_rate_view_1", "Open Social, then tap Long View.")],
  },
  {
    id: "s3_rate_1", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.urgency.1", "kyrs.impact.1"],
    waitFor: ["kyrs:urgency:1", "kyrs:impact:1"],
    lines: [L("s3_rate_1_1", "Tap Urgency: how soon must it be done? Then Importance: how much it changes this sector.")],
  },
  {
    id: "s3_rate_2", stop: 3, speaker: "kyrs", screen: "deitytool",
    targets: ["kyrs.back", "kyrs.list.health", "kyrs.view", "kyrs.urgency.1", "kyrs.impact.1"],
    waitFor: ["kyrs:lists", "kyrs:list:health", "kyrs:view:long", "kyrs:urgency:1", "kyrs:impact:1"],
    lines: [L("s3_rate_2_1", "Now Health. Go back, open it, and do the same.")],
  },
  {
    id: "s3_done", stop: 3, speaker: "kyrs", screen: "deitytool",
    lines: [
      L("s3_done_1", "Now I know the priority of your tasks."),
      L("s3_done_2", "I'll put them in your schedule where they belong."),
    ],
  },
  {
    id: "s3_return", stop: 3, speaker: "syqi", screen: "deitytool",
    target: "tool.back",
    waitFor: "nav:self",
    lines: [
      L("s3_return_1", "Your work has an order now."),
      L("s3_return_2", "Next, the doing. Find METIS."),
    ],
  },
  {
    id: "s4_handoff", stop: 4, speaker: "syqi", screen: "self",
    target: "statue.metis",
    waitFor: "deity:open:metis",
    lines: [
      L("s4_handoff_1", "Fourth stop: Execute. Getting there."),
      L("s4_handoff_2", "METIS makes it happen. Tap her."),
    ],
  },
  {
    id: "s4_intro", stop: 4, speaker: "metis", screen: "self",
    target: "deityfocus.tool",
    waitFor: "nav:deitytool",
    lines: [
      L("s4_intro_1", "I'm METIS. I turn plans into motion."),
      L("s4_intro_2", "Every task is broken into Steps."),
      L("s4_intro_3", "Only one Step is active at a time. That's the one you do."),
      L("s4_intro_4", "Now open my tool. Tap the arrow on the right."),
    ],
  },
  {
    id: "s4_action_own", stop: 4, speaker: "metis", screen: "deitytool",
    target: "metis.agenda",
    lines: [
      L("s4_action_own_1", "Here's today, in priority order, straight from KYRS."),
      L("s4_action_own_2", "Add your own task in an empty row. Hold the target and drag to reorder. Then tap play."),
    ],
  },
  {
    id: "s4_action_time", stop: 4, speaker: "metis", screen: "deitytool",
    target: "metis.row1.time", waitFor: "metis:time",
    lines: [L("s4_action_time_1", "Type a start time for your first task, then press return.")],
  },
  {
    id: "s4_action_link", stop: 4, speaker: "metis", screen: "deitytool",
    targets: ["metis.row1.crosshair", "metis.row1.aim"],
    waitFor: ["metis:picker", "metis:linked"],
    lines: [L("s4_action_link_1", "Tap its target, then pick the Aim it serves.")],
  },
  {
    id: "s4_done", stop: 4, speaker: "metis", screen: "deitytool",
    lines: [
      L("s4_done_1", "Your day is ordered, and your first task serves an Aim."),
      L("s4_done_2", "Do the top one. Then the next.")
    ],
  },
  {
    id: "s4_return", stop: 4, speaker: "syqi", screen: "deitytool",
    target: "tool.back",
    waitFor: "nav:self",
    lines: [
      L("s4_return_1", "You can act. Now the last piece: looking back."),
      L("s4_return_2", "Find CLIO."),
    ],
  },
  {
    id: "s5_handoff", stop: 5, speaker: "syqi", screen: "self",
    target: "statue.clio",
    waitFor: "deity:open:clio",
    lines: [
      L("s5_handoff_1", "Last stop: Revise. What changed?"),
      L("s5_handoff_2", "That's CLIO. Tap her."),
    ],
  },
  {
    id: "s5_intro", stop: 5, speaker: "clio", screen: "self",
    target: "deityfocus.tool",
    waitFor: "nav:deitytool",
    lines: [
      L("s5_intro_1", "I'm CLIO. I help you look back honestly."),
      L("s5_intro_2", "When a Step ends, you tell me how it went."),
      L("s5_intro_3", "Complete, Partial, or Incomplete. All three are fine."),
      L("s5_intro_4", "Now open my tool. Tap the arrow on the right."),
    ],
  },
  {
    id: "s5_action_outcome", stop: 5, speaker: "clio", screen: "deitytool",
    target: "clio.outcome", waitFor: "clio:outcome",
    lines: [L("s5_action_outcome_1", "Choose how it went. All three are fine.")],
  },
  {
    id: "s5_action_note", stop: 5, speaker: "clio", screen: "deitytool",
    target: "clio.note", waitFor: "clio:note",
    lines: [L("s5_action_note_1", "Add a note if you like, then press return. Or skip.")],
  },
  {
    id: "s5_action_save", stop: 5, speaker: "clio", screen: "deitytool",
    target: "clio.save", waitFor: "clio:saved",
    lines: [L("s5_action_save_1", "Press Save to record it.")],
  },
  {
    id: "s5_done", stop: 5, speaker: "clio", screen: "deitytool",
    lines: [
      L("s5_done_1", "Honest and recorded. That's how a system learns you."),
    ],
  },
  {
    id: "s5_return", stop: 5, speaker: "syqi", screen: "deitytool",
    target: "tool.back",
    waitFor: "nav:self",
    lines: [
      L("s5_return_1", "That's all five. Let's go back to the Mountain."),
      L("s5_return_2", "Tap the down arrow."),
    ],
  },
  {
    id: "done", stop: 5, speaker: "syqi", screen: "compass",
    lines: [
      L("done_1", "Look at the Mountain. Five Endeavours, your first tasks, one active Step."),
      L("done_2", "That's your system, set up. The bar is full."),
      L("done_3", "Your system is ready. Start with your active Step."),
    ],
  },
];

export const STOP_LABELS: Record<number, string> = {
  0: 'Getting started',
  1: 'ATLAS',
  2: 'KRNOS',
  3: 'KYRS',
  4: 'METIS',
  5: 'CLIO',
};
